import React from 'react'
import { Slider as AntDSlider } from 'antd'
import PropTypes from 'prop-types'

const Slider = ({ step, max, min, onChange, value, tipFormatter }) => (
  <AntDSlider
    step={step}
    max={max}
    min={min}
    onChange={onChange}
    value={value}
    tipFormatter={tipFormatter}
  />
)

Slider.propTypes = {
  step: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
  tipFormatter: PropTypes.func,
}

export default Slider
